<template>
  <div>
    <Menu />
    <div class="container main" v-if="id_funcao == 1 || id_funcao == 2">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Última sincronização"
            description=""
            url="/administracao"
            modalDocument="DocRessincronizacao"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros
            :cadastros="cadastros"
            :loading="loading"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import TabelaCadastros from './TabelaCadastros.vue'
import { mapState } from 'vuex'
import SectionTitle from '@/components/SectionTitle'

export default {
  metaInfo: {
    title: 'Última sincronização',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    TabelaCadastros,
    SectionTitle,
  },
  computed: {
    ...mapState(['id_funcao']),
  },
  data() {
    return {
      cadastros: [],
      loading: false,
    }
  },
  mounted() {
    this.buscarRessincronizacao()
  },
  methods: {
    /**
     * Busca os dados da ressincronização
     */
    async buscarRessincronizacao() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/v2/municipio/ressincronizacao/' + this.$store.state.cod_ibge
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
